// START IMPORTS
import { Box, Card, Grid, styled, Text } from '@ltvco/refresh-lib/theme';
import {
  UnclaimedMoneyHeader,
  SearchNewUnclaimedMoneyForm,
} from '@ltvco/refresh-lib/unclaimedMoney';
import { HelpfulTips, Faq } from '@ltvco/refresh-lib/v1';
import { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';

import {
  unclaimedMoneyFaq,
  unclaimedMoneyHelpfulTips,
} from './unclaimedMoneyConstants';
// END IMPORTS

// START STYLED_COMPONENTS
const StyledCard = styled(Card)(({ theme }) => ({
  backgroundColor: '#F9F7FF',
  border: '0.5px solid',
  // TODO REVIEW TO CORRECT COLOR
  borderColor: theme.palette.text.primary,
  padding: '15px',
  boxShadow: theme.palette.background.light,
  marginBottom: theme.spacing(7),
}));
// END STYLED_COMPONENTS

// START HELPER_FUNCTIONS
function useQueryParams(params: string) {
  return useMemo(() => new URLSearchParams(params), [params]);
}
// END HELPER_FUNCTIONS

export function UnclaimedMoney() {
  // START HOOKS_AND_QUERIES
  const { search } = useLocation();
  const queryParams = useQueryParams(search);
  // END HOOKS_AND_QUERIES

  // START DERIVED_DATA_AND_UTILS
  const fname = queryParams.get('fname') || '';
  const lname = queryParams.get('lname') || '';
  const state = queryParams.get('state') || '';
  // END DERIVED_DATA_AND_UTILS

  // START STATE_MANAGEMENT
  const [stateList] = useState<string[]>(state ? [state] : []);
  // END STATE_MANAGEMENT

  // START EFFECTS
  useEffect(() => {
    document.title = 'Unclaimed Money - NumberGuru';
  }, []);
  // END EFFECTS

  // START RENDER
  return (
    <>
      <UnclaimedMoneyHeader />
      <StyledCard>
        <Grid container direction="row" justifyContent="space-between">
          <Grid width={'100%'}>
            <Text variant="h5" sx={{ fontWeight: 'bold', mt: 2.5, mb: 1.5 }}>
              There’s an estimated $70 billion worth of unclaimed money in the
              United States.
            </Text>
            <Text variant="h2">How much could be yours?</Text>
          </Grid>
        </Grid>
        <Box sx={{ mb: 7.25 }}>
          <SearchNewUnclaimedMoneyForm
            fname={fname}
            lname={lname}
            stateList={stateList}
          />
        </Box>
        <HelpfulTips tips={unclaimedMoneyHelpfulTips} />
      </StyledCard>
      <Faq faqItems={unclaimedMoneyFaq} />
    </>
  );
  // END RENDER
}
